import { useAuth } from '@/contexts/AuthContext'
import { getLimite, TRIAL_LIMIT } from '@/lib/planLimits'

export type SubscriptionStatus = 'trial' | 'trialing' | 'active' | 'past_due' | 'canceled' | 'expired' | 'canceling'

export function useSubscription() {
  const { loja, trialAvaliacoesUsadas } = useAuth()

  if (!loja) {
    return {
      status: 'trial' as SubscriptionStatus,
      plano: 'basico' as const,
      isActive: false,
      isTrial: false,
      isCanceling: false,
      trialAvaliacoesRestantes: TRIAL_LIMIT,
      isExpired: true,
      hasStripeSubscription: false,
      hasActiveStripeSubscription: false,
      limiteAvaliacao: getLimite('basico'),
    }
  }

  const status = (loja.stripe_subscription_status ?? 'trial') as SubscriptionStatus
  const plano = loja.plano
  const hasStripeSubscription = Boolean(loja.stripe_subscription_id)
  const isCortesia = loja.cortesia ?? false

  const isCanceling = status === 'canceling'
  const isStripeActive = ['active', 'trialing', 'canceling'].includes(status)
  const hasActiveStripeSubscription = hasStripeSubscription && ['active', 'trialing'].includes(status)

  const trialAvaliacoesRestantes = !hasStripeSubscription
    ? Math.max(0, TRIAL_LIMIT - trialAvaliacoesUsadas)
    : 0

  const isTrial = !isCortesia && !hasStripeSubscription && trialAvaliacoesRestantes > 0
  const isActive = isCortesia
    ? loja.ativo
    : hasStripeSubscription
      ? loja.ativo && isStripeActive
      : loja.ativo && trialAvaliacoesRestantes > 0
  const isExpired = !isActive

  return {
    status,
    plano,
    isActive,
    isTrial,
    isCortesia,
    isCanceling,
    trialAvaliacoesRestantes,
    isExpired,
    hasStripeSubscription,
    hasActiveStripeSubscription,
    limiteAvaliacao: getLimite(plano),
  }
}
